import React, { useMemo, useState, useEffect } from "react";
import { useForm } from "react-hook-form";
import Button from "../../components/utils/Button";
import Table from "../../components/utils/Table";
import CardLayout from "../../components/utils/CardLayout";
import { useDispatch, useSelector } from "react-redux";
import reportActions from "../../redux/reports/actions";
import { downloadExcelSampleFile } from "../../helpers/commonFunction";
import moment from "moment";

const { getrechargeBatchReports } = reportActions;
const dateFormat = process.env.REACT_APP_DATE_TIME_FORMAT;


const RechargeBatchDetails = ({ selectedBatchId, onBack }) => {
    const dispatch = useDispatch();
    const [searchItem, setSearchItem] = useState("");
    const beforeTwoDays = new Date();
    beforeTwoDays.setDate(beforeTwoDays.getDate() - 2);
    const { rechargeBatchReports, rechargeBatchReportsLoading, } = useSelector((state) => state.reports)
    const { defaultCurrency } = useSelector((state) => state.auth);

    const { register, handleSubmit, reset, formState: { errors } } = useForm({
        mode: "onChange",
        defaultValues: {
            batchID: "",
            isBatchDetail: true,
        },
    });

    useEffect(() => {
        if (selectedBatchId) {
            dispatch(getrechargeBatchReports({
                batchID: selectedBatchId,
                isBatchDetail: true,
            }));
        }
    }, [selectedBatchId]);


    const columns = [
        { displayName: "Batch ID", key: "BatchId" },
        { displayName: "Transaction ID", key: "TransactionId" },
        { displayName: "MSISDN", key: "MobileNumber" },
        { displayName: "Plan Name", key: "PlanName" },
        // { displayName: "Plan Amount", key: "PlanAmount" },
        { displayName: "Charged Amount", key: "ChargedAmount" },
        { displayName: "Validity Days", key: "ValidityDays" },
        { displayName: "Recharge Date", key: "RechargeDate" },
        { displayName: "Status", key: "Status" },

    ];

    const filteredItems = useMemo(() => {
        return Array.isArray(rechargeBatchReports) && rechargeBatchReports.length > 0
            ? rechargeBatchReports.filter(item => {
                if (!searchItem) return true;
                return Object.values(item).some(val => typeof val === "string" && val.toLowerCase().includes(searchItem.toLowerCase()));
            })
            : [];
    }, [rechargeBatchReports, searchItem]);

    const rowData = useMemo(() => {
        return (filteredItems || []).map((item) => ({
            BatchId: item?.BatchID,
            TransactionId: item?.TransactionID,
            MobileNumber: item?.MobileNumber,
            PlanName: item?.PlanName,
            // PlanAmount: defaultCurrency + '' + item?.PlanAmount,
            ChargedAmount: defaultCurrency + '' + item?.ChargedAmount,
            ValidityDays: item?.ValidityDays,
            RechargeDate: moment(item?.RechargeDate).format(dateFormat),
            Status: (<span className={`badge ${item?.StatusID == 23 ? "bg-warning" : item?.StatusID == 27 ? 'bg-success' : item?.StatusID == 28 ? "bg-danger" : 'bg-info'}`}
            > {item?.Remarks}
            </span>
            ),
        }));
    }, [filteredItems]);

    const handleBack = () => {
        onBack();
    }

    const handleExportExcel = () => {
        const data = filteredItems.map(item => ({
            "Batch ID": item["BatchID"],
            "Transaction ID": item["TransactionID"],
            "MSISDN": item["MobileNumber"],
            "Plan Name": item["PlanName"],
            // "Plan Amount": defaultCurrency + '' + item["PlanAmount"],
            "Charged Amount": defaultCurrency + '' + item["ChargedAmount"],
            "Validity Days": item["ValidityDays"],
            "Recharge Date": moment(item?.RechargeDate).format(dateFormat),
            "Status": item["Remarks"],
        }));

        downloadExcelSampleFile(data, "recharge-batch-detail.xlsx");
    };

    return (
        <CardLayout
            title={<> Recharge Batch Details<span style={{ color: "#4b9b60" }}> :#{selectedBatchId}
            </span>
            </>
            }
            icon="ri-file-chart-line "
            rightContent={
                <div className="d-flex flex-wrap align-items-center gap-1">
                    <input
                        type="search"
                        style={{ width: "300px", }}
                        onChange={(e) => setSearchItem(e.target.value)}
                        className="form-control form-control-sm"
                        placeholder="Search..." />
                    <Button
                        title="Back"
                        buttonType="button"
                        icon={<i className="ri-arrow-left-line me-1" />}
                        variant="primary"
                        style={{
                            padding: "5px 10px",
                        }}
                        onClick={() => handleBack()}
                    />
                    <Button
                        title="Excel"
                        buttonType="button"
                        variant="secondary"
                        onClick={handleExportExcel}
                        icon={<i className="ri-download-cloud-line me-2" />}
                    />
                </div>
            }
        >
            {/* Table */}
            <div className="mt-2">
                <Table
                    columns={columns}
                    data={rowData}
                    pagination
                    loading={rechargeBatchReportsLoading}
                    tableHeight="285px"
                />
            </div>
        </CardLayout>
    );
};

export default RechargeBatchDetails;

